// main nav
export const VIEW_CREATE_USER = 'VIEW_CREATE_USER';
export const VIEW_ATT_SUBS_GROUP = 'VIEW_ATT_SUBS_GROUP';
export const VIEW_SIMO_SUBS_GROUP = 'VIEW_SIMO_SUBS_GROUP';
export const VIEW_ALL_QUICK_SUBS = 'VIEW_SIMO_SUBS_GROUP';
export const VIEW_SEARCH_QUICK_SUBS = 'VIEW_SIMO_SUBS_GROUP';
export const VIEW_QUICK_PORT_OUTS = 'VIEW_QUICK_PORT_OUTS';
export const VIEW_BILLING_GROUP = 'VIEW_BILLING_GROUP';
export const VIEW_PAYMENT_ARRANGEMENTS = 'VIEW_PAYMENT_ARRANGEMENTS';
export const VIEW_ROLLING_ARRANGEMENTS = 'VIEW_ROLLING_ARRANGEMENTS';
export const VIEW_REPORTING_GROUP = 'VIEW_REPORTING_GROUP';
export const VIEW_MASS_ACTIONS_GROUP = 'VIEW_MASS_ACTIONS_GROUP';
export const VIEW_DEVICE_PROTECTION_GROUP = 'VIEW_DEVICE_PROTECTION_GROUP';
export const VIEW_ORDERS_GROUP = 'VIEW_ORDERS_GROUP';
export const VIEW_ARCHIVE_GROUP = 'VIEW_ARCHIVE_GROUP';
export const VIEW_RESELLER_GROUP = 'VIEW_RESELLER_GROUP';

// top nav
export const VIEW_TOP_SUBS_GROUPS = 'VIEW_TOP_SUBS_GROUPS';
export const VIEW_TOP_FEEDBACK = 'VIEW_TOP_FEEDBACK';

// user
export const VIEW_USER_CREDIT = 'VIEW_USER_CREDIT';
export const VIEW_USER_LOGS = 'VIEW_USER_LOGS';
export const VIEW_USER_PREACTIVATION = 'VIEW_USER_PREACTIVATION';
export const VIEW_USER_ROLLING_PAYMENTS = 'VIEW_USER_ROLLING_PAYMENTS';
export const VIEW_USER_LOGIN_DEVICES = 'VIEW_USER_LOGIN_DEVICES';
export const VIEW_USER_RATE_CARD = 'VIEW_USER_RATE_CARD';
export const EDIT_USER_PROFILE = 'EDIT_USER_PROFILE';
export const EDIT_USER_EMAIL = 'EDIT_USER_EMAIL';
export const EDIT_USER_GROUP = 'EDIT_USER_GROUP';
export const DEACTIVATE_USER = 'DEACTIVATE_USER';
export const UPDATE_CREATOR = 'UPDATE_CREATOR';
export const CHANGE_AUTOPAY = 'CHANGE_AUTOPAY';
export const CHANGE_TAX_EXEMPT = 'CHANGE_TAX_EXEMPT';
export const CHANGE_PLAN_FEE_EXEMPT = 'CHANGE_PLAN_FEE_EXEMPT';
export const CHANGE_USER_SIMO_CYCLE = 'CHANGE_USER_SIMO_CYCLE';
export const CHANGE_USER_SIMO_ACCOUNT = 'CHANGE_USER_SIMO_ACCOUNT';

//address
export const EDIT_ADDRESS = 'EDIT_ADDRESS';
export const CREATE_ADDRESS = 'CREATE_ADDRESS';

// att
export const EXPIRE_ATT_SUB = 'EXPIRE_ATT_SUB';
export const SET_ATT_UPCOMING_PLAN = 'SET_ATT_UPCOMING_PLAN';
export const SET_ATT_PLAN = 'SET_ATT_PLAN';
export const UPGRADE_ATT_INVOICE = 'UPGRADE_ATT_INVOICE';
export const UPDATE_ATT_DEVICE = 'UPDATE_ATT_DEVICE';
export const ACTIVATE_ATT_SUB = 'ACTIVATE_ATT_SUB';
export const SUSPEND_ATT_SUB = 'SUSPEND_ATT_SUB';
export const RESTORE_ATT_SUB = 'RESTORE_ATT_SUB';
export const ADD_ATT_LEASE = 'ADD_ATT_LEASE';
export const CHANGE_ATT_MDN = 'CHANGE_ATT_MDN';
export const TRANSFER_ATT_SUB = 'TRANSFER_ATT_SUB';
export const VIEW_ATT_VERIFICATION_CODE = 'VIEW_ATT_VERIFICATION_CODE';
export const SEARCH_ATT_SUB_BY_IMSI = 'SEARCH_ATT_SUB_BY_IMSI';

// simo sub
export const SET_SIMO_PLAN = 'SET_SIMO_PLAN';
export const SET_SIMO_UPCOMING_PLAN = 'SET_SIMO_UPCOMING_PLAN';
export const UPGRADE_SIMO_INVOICE = 'UPGRADE_SIMO_INVOICE';
export const ACTIVATE_SIMO_SUB = 'ACTIVATE_SIMO_SUB';
export const CHANGE_SIMO_AUTO_RENEW = 'CHANGE_SIMO_AUTO_RENEW';
export const EXPIRE_SIMO_SUB = 'EXPIRE_SIMO_SUB';
export const SET_SIMO_IMMEDIATE_RENEWAL = 'SET_SIMO_IMMEDIATE_RENEWAL';

// simo device
export const UPDATE_SIMO_DEVICE = 'UPDATE_SIMO_DEVICE';
export const CHANGE_SIMO_ACCOUNT = 'CHANGE_SIMO_ACCOUNT';
export const EXPIRE_SIMO_DEVICE = 'EXPIRE_SIMO_DEVICE';
export const SUSPEND_SIMO_DEVICE = 'SUSPEND_SIMO_DEVICE';
export const RESTORE_SIMO_DEVICE = 'RESTORE_SIMO_DEVICE';
export const TRANSFER_SIMO_DEVICE = 'TRANSFER_SIMO_DEVICE';

// quick
export const SET_QUICK_UPCOMING_PLAN = 'SET_QUICK_UPCOMING_PLAN';
export const SET_QUICK_PLAN = 'SET_QUICK_PLAN';
export const UPGRADE_QUICK_INVOICE = 'UPGRADE_QUICK_INVOICE';
export const EXPIRE_QUICK_SUB = 'EXPIRE_QUICK_SUB';
export const UPDATE_QUICK_DEVICE = 'UPDATE_QUICK_DEVICE';
export const SUSPEND_QUICK_SUB = 'SUSPEND_QUICK_SUB';
export const RESTORE_QUICK_SUB = 'RESTORE_QUICK_SUB';
export const GET_QUICK_USAGE = 'GET_QUICK_USAGE';
export const CHANGE_QUICK_VOICEMAIL_PIN = 'CHANGE_QUICK_VOICEMAIL_PIN';
export const DELETE_QUICK_VOICEMAIL_PIN = 'DELETE_QUICK_VOICEMAIL_PIN';
export const CHANGE_QUICK_CALLER_ID = 'CHANGE_QUICK_CALLER_ID';
export const CHANGE_QUICK_MDN = 'CHANGE_QUICK_MDN';
export const ACTIVATE_QUICK_SUB = 'ACTIVATE_QUICK_SUB';
export const SET_QUICK_SERVICE_ADDRESS = 'SET_QUICK_SERVICE_ADDRESS';
export const UPDATE_QUICK_STATUS = 'UPDATE_QUICK_STATUS';
export const UPDATE_QUICK_SERVICE_CODES = 'UPDATE_QUICK_SERVICE_CODES';
export const VIEW_QUICK_VERIFICATION_CODE = 'VIEW_QUICK_VERIFICATION_CODE';
export const TRANSFER_QUICK_SUB = 'TRANSFER_QUICK_SUB';
export const REACTIVATE_QUICK_SUB = 'REACTIVATE_QUICK_SUB';
export const CREATE_QUICK_NEW_PORT = 'CREATE_QUICK_NEW_PORT';

//payment methods
export const CREATE_PAYMENT_METHOD = 'CREATE_PAYMENT_METHOD';
export const UPDATE_PAYMENT_METHOD = 'UPDATE_PAYMENT_METHOD';
export const DELETE_PAYMENT_METHOD = 'DELETE_PAYMENT_METHOD';
export const SET_DEFAULT_PAYMENT_METHOD = 'SET_DEFAULT_PAYMENT_METHOD';
export const VIEW_PAYMENT_METHODS = 'VIEW_PAYMENT_METHODS';

//purchases
export const VIEW_PURCHASES = 'VIEW_PURCHASES';
export const CREATE_RENEWAL_INVOICE = 'CREATE_RENEWAL_INVOICE';
export const SET_OVERDUE_PURCHASE = 'SET_OVERDUE_PURCHASE';
export const ALLOCATE_LINEITEMS = 'ALLOCATE_LINEITEMS';

//prices
export const VIEW_PRICES = 'VIEW_PRICES';

//custom plans
export const VIEW_CUSTOM_PLAN_PRICING = 'VIEW_CUSTOM_PLAN_PRICING';
export const MODIFY_CUSTOM_PLAN = 'MODIFY_CUSTOM_PLAN';
